export default "__VITE_ASSET__CGHw1gb4__"